import { FormArray, FormControl, FormGroup } from '@angular/forms';

export class FormControlUtils {
  static anyErrorDisplayed(formGroup: FormGroup): boolean {
    for (let controlsKey in formGroup.controls) {
      if(formGroup.controls[controlsKey] instanceof FormControl){
        const control:FormControl = <FormControl>formGroup.controls[controlsKey];
        if (!control.valid && (control.touched || control.dirty) && !control.disabled){
          return true;
        }
      } else if(formGroup.controls[controlsKey] instanceof FormArray && (<FormArray>formGroup.controls[controlsKey]).length){
        const controlsArr:FormArray = <FormArray>formGroup.controls[controlsKey];
        for (let controlsArrKey in controlsArr.controls) {
          const controlsGrp:FormGroup = <FormGroup>controlsArr.controls[controlsArrKey];

          if(this.anyErrorDisplayed(controlsGrp)){
            return true;
          }
        }
      } else if(formGroup.controls[controlsKey] instanceof FormGroup){
        const controlsGrp:FormGroup = <FormGroup>formGroup.controls[controlsKey];
        if(this.anyErrorDisplayed(controlsGrp)){
          return true;
        }
      }
    }
    return false;
  }
  static markAllTouched(formGroup: FormGroup, touched: boolean = true) {
    for (let controlsKey in formGroup.controls) {
      if(formGroup.controls[controlsKey] instanceof FormControl){
        const control:FormControl = <FormControl>formGroup.controls[controlsKey];
        if(touched){
          control.markAsTouched();
        } else {
          control.markAsUntouched();
          control.markAsPristine();
        }
      } else if(formGroup.controls[controlsKey] instanceof FormArray && (<FormArray>formGroup.controls[controlsKey]).length){
        const controlsArr:FormArray = <FormArray>formGroup.controls[controlsKey];
        for (let controlsArrKey in controlsArr.controls) {
          const controlsGrp:FormGroup = <FormGroup>controlsArr.controls[controlsArrKey];
          this.markAllTouched(controlsGrp, touched);
        }
      } else if(formGroup.controls[controlsKey] instanceof FormGroup){
        const controlsGrp:FormGroup = <FormGroup>formGroup.controls[controlsKey];
        this.markAllTouched(controlsGrp, touched);
      }
    }
    return false;
  }

}
